import type { CopyDriveItemCommand } from '@/drive/entities/DriveCommand/CopyDriveItemCommand';
import type { MoveDriveItemCommand } from '@/drive/entities/DriveCommand/MoveDriveItemCommand';
import type { SubscribeToCollectionCommand } from '@/drive/entities/DriveCommand/SubscribeToCollectionCommand';
import { ProductItem } from '@/drive/entities/DriveItem/DriveItem';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { TransientDriveItem } from '@/drive/entities/transientDriveItem';
import { AccessInheritanceSubject } from '@/drive/types/AccessInheritanceSubject';
import { DriveItemRequest } from '@/drive/types/DriveItemRequest';
import { BaseProductType } from '@/product/constants/productTypes';
import { ProductId } from '@/product/entity/Product';

export type DriveDestinationCommand =
  | BatchAddDriveItemsCommand
  | SubscribeToCollectionCommand
  | CopyDriveItemCommand
  | MoveDriveItemCommand;

export function toCommandCollectionRequest(command: DriveDestinationCommand): Nullable<AddToCollectionRequest> {
  return 'collectionRequest' in command ? command.collectionRequest : null;
}

export function toCommandDriveItemId(command: DriveDestinationCommand): Nullable<DriveItemId> {
  return 'driveItemId' in command ? command.driveItemId : null;
}

export function toCommandItemsCount(command: DriveDestinationCommand): number {
  return 'requests' in command ? command.requests.length : 1;
}

export interface AccessInheritanceAwareCommand {
  getAccessSubjects(): Promise<AccessInheritanceSubject[]>;
}

export interface AddToCollectionRequest {
  productType: BaseProductType;
  productIds: ProductId[];
}

export interface MoveToCollectionRequest extends AddToCollectionRequest {
  productItem: ProductItem;
}

export abstract class BatchAddDriveItemsCommand implements AccessInheritanceAwareCommand {
  abstract readonly requests: DriveItemRequest[];

  abstract readonly collectionRequest: Nullable<AddToCollectionRequest>;

  abstract getAccessSubjects(): Promise<AccessInheritanceSubject[]>;

  abstract getSourceItems(): Promise<Nullable<TransientDriveItem>[]>;
}
